import React, { useState, useEffect } from 'react';
import BaseModal from '../../../utils/BaseModal';
import SimpleBuyOrder from './SimpleBuyOrder';
import { SteamAccount } from '../../../../store/slices/authSlice';

type Props = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  itemName: string;
  referencePriceMinor?: number;
  initialData?: {
    priceMinor: number;
    quantity: number;
    steamAccount: SteamAccount;
    orderId?: number;
  };
};

const CreateBuyOrderModal: React.FC<Props> = ({ open, onClose, onSuccess, itemName, referencePriceMinor, initialData }) => {
  const [selectedSteamAccount, setSelectedSteamAccount] = useState<SteamAccount | null>(null);

  // Sync state when initialData changes (for Edit mode)
  useEffect(() => {
    if (initialData?.steamAccount) {
      setSelectedSteamAccount(initialData.steamAccount);
    } else {
      setSelectedSteamAccount(null);
    }
  }, [initialData, open]);

  return (
      <BaseModal open={open} title={initialData ? "Edit Buy Order" : "Create Buy Order"} onAbort={onClose} maxWidth="md">
        <div className="flex flex-col gap-6 dark:bg-neutral-900/50 bg-white rounded-md">
          {/* Content Area */}
          <div className="relative bg-neutral-900/40 border border-neutral-800/60 rounded-md p-8 min-h-[440px]">
            <SimpleBuyOrder
                itemName={itemName}
                onSuccess={onSuccess}
                referencePriceMinor={referencePriceMinor}
                selectedSteamAccount={selectedSteamAccount}
                onSteamAccountChange={setSelectedSteamAccount}
                initialData={initialData}
            />
          </div>
        </div>
      </BaseModal>
  );
};

export default CreateBuyOrderModal;